'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { consentState, trackPageView } from '@/lib/productAnalytics'

const CONSENT_UPDATED_EVENT = 'arena-cookie-consent-updated'

/**
 * Sends one `page_view` per route: on mount, on every `usePathname()` change and
 * once more when the cookie banner changes the decision, so the next event
 * carries the new `consent_state`. Renders nothing.
 */
const PageViewTracker = () => {
  const pathname = usePathname()
  const lastSent = useRef<string | null>(null)

  useEffect(() => {
    const send = () => {
      const key = `${pathname}|${consentState()}`
      if (lastSent.current === key) return
      lastSent.current = key
      trackPageView(pathname)
    }
    send()
    window.addEventListener(CONSENT_UPDATED_EVENT, send)
    return () => window.removeEventListener(CONSENT_UPDATED_EVENT, send)
  }, [pathname])

  return null
}

export default PageViewTracker
